import { render, staticRenderFns } from "./CmgHowItWorks.vue?vue&type=template&id=98ba3b98&scoped=true&lang=pug"
import script from "./cmg-how-it-works.ts?vue&type=script&lang=ts&external"
export * from "./cmg-how-it-works.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgHowItWorks.vue?vue&type=style&index=0&id=98ba3b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ba3b98",
  null
  
)

export default component.exports